var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 12.2222C1.82407 12.2222 1.3912 12.044 1.03472 11.6875C0.678241 11.331 0.5 10.8981 0.5 10.3889V8.55556H2.33333V0H11.5V10.3889C11.5 10.8981 11.3218 11.331 10.9653 11.6875C10.6088 12.044 10.1759 12.2222 9.66667 12.2222H2.33333ZM9.66667 11C9.83982 11 9.98495 10.9414 10.1021 10.8243C10.2192 10.7072 10.2778 10.562 10.2778 10.3889V1.22222H3.55556V8.55556H9.05556V10.3889C9.05556 10.562 9.11412 10.7072 9.23125 10.8243C9.34838 10.9414 9.49352 11 9.66667 11ZM4.16667 4.27778V3.05556H9.66667V4.27778H4.16667ZM4.16667 6.11111V4.88889H9.66667V6.11111H4.16667ZM2.33333 11H7.83333V9.77778H1.72222V10.3889C1.72222 10.562 1.78079 10.7072 1.89792 10.8243C2.01505 10.9414 2.16019 11 2.33333 11ZM2.33333 11H1.72222H7.83333H2.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.f2d0199272db2e96fe7e5ea0aa617b0e.svg";
export { ForwardRef as ReactComponent };